import * as A from "react";
import me, { useState as z, useLayoutEffect as j, useMemo as $e } from "react";
var Z = { exports: {} }, K = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ue;
function De() {
  if (ue)
    return K;
  ue = 1;
  var e = me;
  function n(p, l) {
    return p === l && (p !== 0 || 1 / p === 1 / l) || p !== p && l !== l;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = e.useSyncExternalStore, c = e.useRef, u = e.useEffect, m = e.useMemo, _ = e.useDebugValue;
  return K.useSyncExternalStoreWithSelector = function(p, l, v, h, C) {
    var S = c(null);
    if (S.current === null) {
      var E = { hasValue: !1, value: null };
      S.current = E;
    } else
      E = S.current;
    S = m(function() {
      function x(t) {
        if (!g) {
          if (g = !0, b = t, t = h(t), C !== void 0 && E.hasValue) {
            var T = E.value;
            if (C(T, t))
              return s = T;
          }
          return s = t;
        }
        if (T = s, r(b, t))
          return T;
        var M = h(t);
        return C !== void 0 && C(T, M) ? T : (b = t, s = M);
      }
      var g = !1, b, s, d = v === void 0 ? null : v;
      return [function() {
        return x(l());
      }, d === null ? void 0 : function() {
        return x(d());
      }];
    }, [l, v, h, C]);
    var y = o(p, S[0], S[1]);
    return u(function() {
      E.hasValue = !0, E.value = y;
    }, [y]), _(y), y;
  }, K;
}
var X = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var se;
function Ie() {
  return se || (se = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = me;
    function n(l, v) {
      return l === v && (l !== 0 || 1 / l === 1 / v) || l !== l && v !== v;
    }
    var r = typeof Object.is == "function" ? Object.is : n, o = e.useSyncExternalStore, c = e.useRef, u = e.useEffect, m = e.useMemo, _ = e.useDebugValue;
    function p(l, v, h, C, S) {
      var E = c(null), y;
      E.current === null ? (y = {
        hasValue: !1,
        value: null
      }, E.current = y) : y = E.current;
      var x = m(function() {
        var d = !1, t, T, M = function(N) {
          if (!d) {
            d = !0, t = N;
            var $ = C(N);
            if (S !== void 0 && y.hasValue) {
              var D = y.value;
              if (S(D, $))
                return T = D, D;
            }
            return T = $, $;
          }
          var B = t, I = T;
          if (r(B, N))
            return I;
          var F = C(N);
          return S !== void 0 && S(I, F) ? I : (t = N, T = F, F);
        }, Y = h === void 0 ? null : h, H = function() {
          return M(v());
        }, G = Y === null ? void 0 : function() {
          return M(Y());
        };
        return [H, G];
      }, [v, h, C, S]), g = x[0], b = x[1], s = o(l, g, b);
      return u(function() {
        y.hasValue = !0, y.value = s;
      }, [s]), _(s), s;
    }
    X.useSyncExternalStoreWithSelector = p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), X;
}
process.env.NODE_ENV === "production" ? Z.exports = De() : Z.exports = Ie();
var Fe = Z.exports, P = (
  // prettier-ignore
  // @ts-ignore
  "default" in A ? A.default : A
), ie = Symbol.for("react-redux-context"), fe = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Ve() {
  if (!P.createContext)
    return {};
  const e = fe[ie] ?? (fe[ie] = /* @__PURE__ */ new Map());
  let n = e.get(P.createContext);
  return n || (n = P.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (n.displayName = "ReactRedux"), e.set(P.createContext, n)), n;
}
var L = /* @__PURE__ */ Ve(), Ye = () => {
  throw new Error("uSES not initialized!");
};
function te(e = L) {
  return function() {
    const r = P.useContext(e);
    if (process.env.NODE_ENV !== "production" && !r)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return r;
  };
}
var ve = /* @__PURE__ */ te(), Se = Ye, ke = (e) => {
  Se = e;
}, We = (e, n) => e === n;
function ze(e = L) {
  const n = e === L ? ve : te(e), r = (o, c = {}) => {
    const { equalityFn: u = We, devModeChecks: m = {} } = typeof c == "function" ? { equalityFn: c } : c;
    if (process.env.NODE_ENV !== "production") {
      if (!o)
        throw new Error("You must pass a selector to useSelector");
      if (typeof o != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof u != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const {
      store: _,
      subscription: p,
      getServerState: l,
      stabilityCheck: v,
      identityFunctionCheck: h
    } = n(), C = P.useRef(!0), S = P.useCallback(
      {
        [o.name](y) {
          const x = o(y);
          if (process.env.NODE_ENV !== "production") {
            const {
              identityFunctionCheck: g,
              stabilityCheck: b
            } = {
              stabilityCheck: v,
              identityFunctionCheck: h,
              ...m
            };
            if (b === "always" || b === "once" && C.current) {
              const s = o(y);
              if (!u(x, s)) {
                let d;
                try {
                  throw new Error();
                } catch (t) {
                  ({ stack: d } = t);
                }
                console.warn(
                  "Selector " + (o.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: y,
                    selected: x,
                    selected2: s,
                    stack: d
                  }
                );
              }
            }
            if ((g === "always" || g === "once" && C.current) && x === y) {
              let s;
              try {
                throw new Error();
              } catch (d) {
                ({ stack: s } = d);
              }
              console.warn(
                "Selector " + (o.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: s }
              );
            }
            C.current && (C.current = !1);
          }
          return x;
        }
      }[o.name],
      [o, v, m.stabilityCheck]
    ), E = Se(
      p.addNestedSub,
      _.getState,
      l || _.getState,
      S,
      u
    );
    return P.useDebugValue(E), E;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var je = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
je ? P.useLayoutEffect : P.useEffect;
function pe(e = L) {
  const n = e === L ? ve : (
    // @ts-ignore
    te(e)
  ), r = () => {
    const { store: o } = n();
    return o;
  };
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
var Ue = /* @__PURE__ */ pe();
function He(e = L) {
  const n = e === L ? Ue : pe(e), r = () => n().dispatch;
  return Object.assign(r, {
    withTypes: () => r
  }), r;
}
ke(Fe.useSyncExternalStoreWithSelector);
const ut = (e = L) => () => He(e)(), st = (e = L) => (n, r) => ze(e)(n, r);
var W = function() {
  return W = Object.assign || function(n) {
    for (var r, o = 1, c = arguments.length; o < c; o++) {
      r = arguments[o];
      for (var u in r)
        Object.prototype.hasOwnProperty.call(r, u) && (n[u] = r[u]);
    }
    return n;
  }, W.apply(this, arguments);
};
function Ee(e, n) {
  var r = {};
  for (var o in e)
    Object.prototype.hasOwnProperty.call(e, o) && n.indexOf(o) < 0 && (r[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var c = 0, o = Object.getOwnPropertySymbols(e); c < o.length; c++)
      n.indexOf(o[c]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[c]) && (r[o[c]] = e[o[c]]);
  return r;
}
var J = { exports: {} }, i = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var le;
function Ge() {
  if (le)
    return i;
  le = 1;
  var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, m = e ? Symbol.for("react.provider") : 60109, _ = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function s(t) {
    if (typeof t == "object" && t !== null) {
      var T = t.$$typeof;
      switch (T) {
        case n:
          switch (t = t.type, t) {
            case p:
            case l:
            case o:
            case u:
            case c:
            case h:
              return t;
            default:
              switch (t = t && t.$$typeof, t) {
                case _:
                case v:
                case E:
                case S:
                case m:
                  return t;
                default:
                  return T;
              }
          }
        case r:
          return T;
      }
    }
  }
  function d(t) {
    return s(t) === l;
  }
  return i.AsyncMode = p, i.ConcurrentMode = l, i.ContextConsumer = _, i.ContextProvider = m, i.Element = n, i.ForwardRef = v, i.Fragment = o, i.Lazy = E, i.Memo = S, i.Portal = r, i.Profiler = u, i.StrictMode = c, i.Suspense = h, i.isAsyncMode = function(t) {
    return d(t) || s(t) === p;
  }, i.isConcurrentMode = d, i.isContextConsumer = function(t) {
    return s(t) === _;
  }, i.isContextProvider = function(t) {
    return s(t) === m;
  }, i.isElement = function(t) {
    return typeof t == "object" && t !== null && t.$$typeof === n;
  }, i.isForwardRef = function(t) {
    return s(t) === v;
  }, i.isFragment = function(t) {
    return s(t) === o;
  }, i.isLazy = function(t) {
    return s(t) === E;
  }, i.isMemo = function(t) {
    return s(t) === S;
  }, i.isPortal = function(t) {
    return s(t) === r;
  }, i.isProfiler = function(t) {
    return s(t) === u;
  }, i.isStrictMode = function(t) {
    return s(t) === c;
  }, i.isSuspense = function(t) {
    return s(t) === h;
  }, i.isValidElementType = function(t) {
    return typeof t == "string" || typeof t == "function" || t === o || t === l || t === u || t === c || t === h || t === C || typeof t == "object" && t !== null && (t.$$typeof === E || t.$$typeof === S || t.$$typeof === m || t.$$typeof === _ || t.$$typeof === v || t.$$typeof === x || t.$$typeof === g || t.$$typeof === b || t.$$typeof === y);
  }, i.typeOf = s, i;
}
var f = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var de;
function Be() {
  return de || (de = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, n = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, c = e ? Symbol.for("react.strict_mode") : 60108, u = e ? Symbol.for("react.profiler") : 60114, m = e ? Symbol.for("react.provider") : 60109, _ = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, v = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, C = e ? Symbol.for("react.suspense_list") : 60120, S = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, y = e ? Symbol.for("react.block") : 60121, x = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function s(a) {
      return typeof a == "string" || typeof a == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      a === o || a === l || a === u || a === c || a === h || a === C || typeof a == "object" && a !== null && (a.$$typeof === E || a.$$typeof === S || a.$$typeof === m || a.$$typeof === _ || a.$$typeof === v || a.$$typeof === x || a.$$typeof === g || a.$$typeof === b || a.$$typeof === y);
    }
    function d(a) {
      if (typeof a == "object" && a !== null) {
        var q = a.$$typeof;
        switch (q) {
          case n:
            var k = a.type;
            switch (k) {
              case p:
              case l:
              case o:
              case u:
              case c:
              case h:
                return k;
              default:
                var ce = k && k.$$typeof;
                switch (ce) {
                  case _:
                  case v:
                  case E:
                  case S:
                  case m:
                    return ce;
                  default:
                    return q;
                }
            }
          case r:
            return q;
        }
      }
    }
    var t = p, T = l, M = _, Y = m, H = n, G = v, N = o, $ = E, D = S, B = r, I = u, F = c, Ce = h, oe = !1;
    function Te(a) {
      return oe || (oe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), ae(a) || d(a) === p;
    }
    function ae(a) {
      return d(a) === l;
    }
    function xe(a) {
      return d(a) === _;
    }
    function we(a) {
      return d(a) === m;
    }
    function Re(a) {
      return typeof a == "object" && a !== null && a.$$typeof === n;
    }
    function Oe(a) {
      return d(a) === v;
    }
    function be(a) {
      return d(a) === o;
    }
    function ge(a) {
      return d(a) === E;
    }
    function Pe(a) {
      return d(a) === S;
    }
    function Ae(a) {
      return d(a) === r;
    }
    function Le(a) {
      return d(a) === u;
    }
    function Me(a) {
      return d(a) === c;
    }
    function Ne(a) {
      return d(a) === h;
    }
    f.AsyncMode = t, f.ConcurrentMode = T, f.ContextConsumer = M, f.ContextProvider = Y, f.Element = H, f.ForwardRef = G, f.Fragment = N, f.Lazy = $, f.Memo = D, f.Portal = B, f.Profiler = I, f.StrictMode = F, f.Suspense = Ce, f.isAsyncMode = Te, f.isConcurrentMode = ae, f.isContextConsumer = xe, f.isContextProvider = we, f.isElement = Re, f.isForwardRef = Oe, f.isFragment = be, f.isLazy = ge, f.isMemo = Pe, f.isPortal = Ae, f.isProfiler = Le, f.isStrictMode = Me, f.isSuspense = Ne, f.isValidElementType = s, f.typeOf = d;
  }()), f;
}
process.env.NODE_ENV === "production" ? J.exports = Ge() : J.exports = Be();
var qe = J.exports, _e = qe, Ke = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Xe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, ye = {};
ye[_e.ForwardRef] = Ke;
ye[_e.Memo] = Xe;
function Ze(e, n, r) {
  if (r === void 0 && (r = Error), !e)
    throw new r(n);
}
var Je = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, Qe = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, et = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: Je,
  onWarn: Qe
};
function tt(e) {
  Ze(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
W(W({}, et), { textComponent: A.Fragment });
var re = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = A.createContext(null)) : A.createContext(null);
re.Consumer;
re.Provider;
var rt = re;
function ne() {
  var e = A.useContext(rt);
  return tt(e), e;
}
var Q;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(Q || (Q = {}));
var ee;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(ee || (ee = {}));
function he(e) {
  var n = function(r) {
    var o = ne(), c = r.value, u = r.children, m = Ee(r, ["value", "children"]), _ = typeof c == "string" ? new Date(c || 0) : c, p = e === "formatDate" ? o.formatDateToParts(_, m) : o.formatTimeToParts(_, m);
    return u(p);
  };
  return n.displayName = ee[e], n;
}
function V(e) {
  var n = function(r) {
    var o = ne(), c = r.value, u = r.children, m = Ee(
      r,
      ["value", "children"]
    ), _ = o[e](c, m);
    if (typeof u == "function")
      return u(_);
    var p = o.textComponent || A.Fragment;
    return A.createElement(p, null, _);
  };
  return n.displayName = Q[e], n;
}
V("formatDate");
V("formatTime");
V("formatNumber");
V("formatList");
V("formatDisplayName");
he("formatDate");
he("formatTime");
const it = () => {
  const { formatMessage: e } = ne();
  return (n, r) => {
    try {
      return e(
        {
          id: n,
          defaultMessage: r == null ? void 0 : r.defaultMessage,
          description: r == null ? void 0 : r.description
        },
        r == null ? void 0 : r.values
      );
    } catch {
      return (r == null ? void 0 : r.defaultMessage) || n;
    }
  };
};
let w, R, O;
const U = (e, n) => n !== void 0 ? n : typeof window < "u" ? window.matchMedia(e).matches : (process.env.NODE_ENV !== "production" && console.warn(
  "`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches."
), !1), ft = (e, n) => {
  const [r, o] = z(U(e, n));
  return j(() => {
    let c = !0;
    const u = window.matchMedia(e), m = () => {
      c && o(!!u.matches);
    };
    return u.addEventListener("change", m, !0), o(u.matches), () => {
      c = !1, u.removeEventListener("change", m, !0);
    };
  }, [e]), r;
}, nt = () => {
  const [e, n] = z(U("(max-width: 480px)"));
  return w || (w = window.matchMedia("(max-width: 480px)")), j(() => {
    let r = !0;
    const o = () => {
      !r || !w || n(!!w.matches);
    };
    return w == null || w.addEventListener("change", o, !0), n((w == null ? void 0 : w.matches) || !1), () => {
      r = !1, w == null || w.removeEventListener("change", o, !0);
    };
  }, []), e;
}, ot = () => {
  const [e, n] = z(
    U("(min-width: 481px) and (max-width: 800px)")
  );
  return R || (R = window.matchMedia(
    "(min-width: 481px) and (max-width: 800px)"
  )), j(() => {
    let r = !0;
    const o = () => {
      !r || !R || n(!!R.matches);
    };
    return R == null || R.addEventListener("change", o, !0), n((R == null ? void 0 : R.matches) || !1), () => {
      r = !1, R == null || R.removeEventListener("change", o, !0);
    };
  }, []), e;
}, at = () => {
  const [e, n] = z(
    U("(min-width: 800px) and (max-width: 1024px)")
  );
  return O || (O = window.matchMedia(
    "(min-width: 800px) and (max-width: 1024px)"
  )), j(() => {
    let r = !0;
    const o = () => {
      !r || !O || n(!!O.matches);
    };
    return O == null || O.addEventListener("change", o, !0), n((O == null ? void 0 : O.matches) || !1), () => {
      r = !1, O == null || O.removeEventListener("change", o, !0);
    };
  }, []), e;
}, lt = () => {
  const e = nt(), n = ot(), r = at(), o = $e(
    () => !e && !n && !r,
    [e, n, r]
  );
  return { isScreenXS: e, isScreenS: n, isScreenM: r, isScreenLG: o };
};
export {
  ut as createUseDispatch,
  st as createUseSelector,
  lt as useDefaultMediaQueries,
  at as useIsScreenM,
  ot as useIsScreenS,
  nt as useIsScreenXS,
  ft as useMedia,
  it as useTranslation
};
